export enum EntityKeys {
  USERS = "users",
}
